import { render, staticRenderFns } from "./emails.html?vue&type=template&id=622481ce&scoped=true&external"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622481ce",
  null
  
)

export default component.exports